<template>
  <div>
    <protocol-header v-if="protocol"
                     :protocol="protocol"
                     :task="task"></protocol-header>
    
    <div class="mt-2 mb-4">
      <div class="nav-scroller border-bottom">
        <div class="nav nav-tabs active" ref="tabs">
          <a href="#format"
             class="nav-link active"
             data-toggle="tab">
            Formato de renovación</a>
          <a href="#attachments"
             class="nav-link"
             data-toggle="tab">
            Anexos</a>
        </div>
      </div>
    </div>
    
    <div class="tab-content">
      <div class="tab-pane active show" id="format"
           role="tabpanel"
           aria-labelledby="format-tab-title">
        <h2 id="format-tab-title" class="d-none">Formato de renovación</h2>
        
        <form onsubmit="return false"
              id="form-format"
              ref="form-format">
          
          <div class="form-group mb-4">
            <span>Formato de renovación anual:</span>
            <a :href="`/${protocol.ethics_renewal.file_path}`">{{ protocol.ethics_renewal.file_name }}</a>
          </div>
          
          <div class="form-group mb-4">
            <label for="dictum_type_id" class="d-block">Dictamen:</label>
            <select name="dictum_type_id"
                    id="dictum_type_id"
                    ref="dictum_type_id"
                    class="form-control"
                    v-model="dictumType">
              <option value="" disabled selected>Seleccione un dictamen</option>
              <option v-for="dictum in dictums"
                      :key="dictum.id"
                      :value="dictum.id"
                      v-text="dictum.title"></option>
            </select>
          </div>
          
          <div class="form-group mb-4">
            <label for="comments" class="d-block">Comentarios:</label>
            <textarea rows="5"
                      cols="5"
                      name="comments"
                      id="comments"
                      ref="comments"
                      v-model="comments"
                      class="form-control"></textarea>
          </div>
          
          <div class="form-group mb-4">
            <label for="dictum-file" class="d-block">Archivo dictamen:</label>
            
            <div class="custom-file">
              <input data-id="dictum-file"
                     accept="application/pdf"
                     name="dictum-file"
                     type="file"
                     id="dictum-file"
                     ref="dictum-file"
                     class="custom-file-input"
                     @change="() => this.format = this.$refs['dictum-file'].files[0]">
              <label for="dictum-file" class="custom-file-label">Seleccione el formato de renovación</label>
            </div>
          </div>
          
          <div class="form-group mb-4">
            <button type="button" class="btn btn-lg btn-primary"
                    @click="saveDictum"
                    :disabled="saving">Guardar dictamen
            </button>
          </div>
        </form>
      </div>
      <div class="tab-pane" id="attachments"
           role="tabpanel"
           aria-labelledby="attachments-tab-title">
        <h2 id="attachments-tab-title" class="d-none">Anexos</h2>
        
        <div class="page-section">
          <div class="section-block m-0 p-0">
            <div class="row">
              <div class="col">
                <files-list v-if="protocol"
                            :model="protocol"
                            :files="attachments"
                            :save-files-function="saveAttachments"
                            title="Eliminar anexo de renovación"
                            content="<p>¿Está seguro de eliminar el anexo?</p>"
                            @delete-file="deleteAttachment"></files-list>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
  import 'jquery-validation'
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import FilesList from './FilesList'
  import ProtocolHeader from './ProtocolHeader'
  
  export default {
    name: 'EthicsRenewal',
    components: {
      FilesList,
      ProtocolHeader,
    },
    props: {
      protocol: Object,
      task: Object,
    },
    data () {
      return {
        format: null,
        saving: false,
        dictums: [],
        dictumType: '',
        comments: null,
      }
    },
    methods: {
      ...mapActions({
        saveEthicsRenewalAttachments: 'protocols/saveEthicsRenewalAttachments',
        removeEthicsRenewalAttachment: 'protocols/removeEthicsRenewalAttachment',
        saveEthicsRenewalDictum: 'protocols/saveEthicsRenewalDictum',
        getEthicsRenewalAttachments: 'protocols/getEthicsRenewalAttachments',
        getEthicsRenewalDictums: 'protocols/getEthicsRenewalDictums',
      }),
      
      async load () {
        this.dictums = await this.getEthicsRenewalDictums()
        
        await this.getEthicsRenewalAttachments({
          protocol: this.protocol,
        })
      },
      
      /**
       * Save attachments.
       *
       * @param files
       * @returns {Promise<void>}
       */
      async saveAttachments (files) {
        const formData = new FormData()
        
        files.forEach(file => {
          formData.append('files[]', file.file)
        })
        
        formData.append('protocol', this.protocol.id)
        
        const response = await this.saveEthicsRenewalAttachments(formData)
        
        const {
                message,
                error,
                status,
              } = response
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.success(message)
        
        $(`#attachments-modal`).modal('hide')
      },
      /**
       * Delete attachment callback.
       *
       * @param file
       * @param callback
       * @returns {Promise<void>}
       */
      async deleteAttachment (file, callback) {
        const response = await this.removeEthicsRenewalAttachment({
          protocol: this.protocol,
          file,
        })
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)
        }
        
        callback(response)
      },
      async saveDictum () {
        if ($(this.$refs['form-format']).valid()) {
          this.saving = true
          
          const formData = new FormData()
          
          formData.append('file', this.format)
          formData.append('protocol', this.protocol.id)
          formData.append('renewal_id', this.protocol.ethics_renewal.id)
          formData.append('comments', this.comments)
          formData.append('dictum_type_id', this.dictumType)
          
          const response = await this.saveEthicsRenewalDictum(formData)
          
          const {
                  message,
                  error,
                  status,
                } = response
          if (status === 'error') {
            AlertManager.error(error)
            
            this.saving = false
            
            return
          }
          
          AlertManager.success(message)
          
          setTimeout(() => location.href = '/', 1000)
        }
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      },
    },
    computed: {
      ...mapGetters(['user']),
      ...mapGetters({
        attachments: 'protocols/renewalAttachments',
      }),
    },
    mounted () {
      const vm = this

      this.load()
      
      $(() => {
        $(this.$refs['form-format']).validate({
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            
            if (element.is(':radio')) {
              label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
            }
            else {
              label.insertAfter(element)
            }
          },
          rules: {
            comments: {
              required: true,
            },
            dictum_type_id: {
              required: true,
            },
            'dictum-file': {
              required: true,
              extension: 'pdf',
              maxsize: (vm.isAdmin() ? 5 : 2) * 1024 * 1024,
            },
          },
          messages: {
            'dictum-file': {
              required: 'El formato es requerido',
              extension: 'El formato del archivo debe ser PDF.',
              maxsize: `El tamaño del archivo no debe superar los ${ vm.isAdmin() ? 5 : 2 } MB.`,
            },
            comments: {
              required: 'Escriba sus comentarios.',
            },
            dictum_type_id: {
              required: 'Seleccione un dictamen',
            },
          },
          submitHandler (form) {
            return false
          },
        })
      })
    },
  }
</script>
